import { Grid, Paper } from "@mui/material"
import useGlobalStore from "../../stores/global"
import { CompactTable, StyledPaper, TableLoadingSkeleton, TablePagination } from "../commons"
import { constructLeaderboardTable, tableHeadersLeaderboard } from "./table"
import { useState } from "react"

const MyReferralTable = () => {
  // const [search, setSearch] = useState('')
  const leaderboard = useGlobalStore((state) => state.leaderboardData)
  const tableRows = leaderboard.sort((a, b) => a.rank - b.rank)
  const tableLeaderboardData = constructLeaderboardTable(tableRows)
  const updateLeaderboardData = useGlobalStore((state) => state.getLeaderboardData)
  const [isDataLoading, setIsDataLoading] = useState(false)


  const tablePagination = async (numberOfItemsToDisplay: number, offset: number) => {
    setIsDataLoading(true)
    await updateLeaderboardData(offset, numberOfItemsToDisplay)
    setIsDataLoading(false)
  }
  const tableContent = isDataLoading ? <TableLoadingSkeleton tableHeaders={tableHeadersLeaderboard ?? []} /> : tableLeaderboardData

  return (
    <Grid item container>
      <StyledPaper color='primary' transparent sx={{
        // backgroundColor: '#283D3E', 
        minWidth: '100%',
        width: '100%',
        borderRadius: 0,
        padding: '0px', //to show border
      }}>
        <Grid container flexDirection={'column'} gap={0}>
          <Paper sx={{
            width: '100%'
          }}>
            <Grid container alignItems={'center'} gap={2}
              justifyContent={'flex-start'}>
              <Grid item sx={{ overflowX: 'auto', width: '100%' }}>
                <CompactTable tableHeader={tableHeadersLeaderboard} tableContent={tableContent} />
                <TablePagination dataLength={tableRows.length} callback={tablePagination} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </StyledPaper>
    </Grid >
  )
}

export default MyReferralTable